export interface IVisitorPhone {
    phoneNumber: string;
}
